import React from 'react';
import { BookOpen, Target, Users, Trophy } from 'lucide-react';

const categories = [
  {
    title: "Business Acronyms",
    examples: ["SMART Goals", "SWOT Analysis", "PEST Analysis"],
    description: "Professional acronyms for business concepts and strategies."
  },
  {
    title: "Educational Acronyms",
    examples: ["STEM", "STEAM", "SEAL"],
    description: "Memorable acronyms for learning and teaching concepts."
  },
  {
    title: "Project Acronyms",
    examples: ["AGILE", "SCRUM", "RAID"],
    description: "Effective acronyms for project management and methodologies."
  }
];

const tips = [
  {
    icon: BookOpen,
    title: "Consider Your Audience",
    content: "Choose words that resonate with your target users."
  },
  {
    icon: Target,
    title: "Keep It Simple",
    content: "Use clear, easy-to-understand words."
  },
  {
    icon: Users,
    title: "Test Pronunciation",
    content: "Ensure your acronym is easy to say."
  },
  {
    icon: Trophy,
    title: "Make It Meaningful",
    content: "Each word should contribute to your message."
  }
];

export default function AcronymGuide() {
  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Complete Guide to Creating Acronyms
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {categories.map((category, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{category.title}</h3>
              <ul className="space-y-2 mb-4">
                {category.examples.map((example, i) => (
                  <li key={i} className="text-blue-600">{example}</li>
                ))}
              </ul>
              <p className="text-gray-600">{category.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-lg shadow-md">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Tips for Creating Effective Acronyms
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {tips.map((tip, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-blue-100 mb-4">
                  <tip.icon className="w-6 h-6 text-blue-600" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{tip.title}</h4>
                <p className="text-gray-600">{tip.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}